import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { regions } from "./regions";
import { getOrgApp } from "../helpers/get-orgApp";

const resourcesTypes = [
  { type: "Instance", domain: "Compute", key: "i-" },
  { type: "Vpc", domain: "Network", key: "vpc-" },
  { type: "SecurityGroup", domain: "Security", key: "sg-" },
  { type: "Snapshot", domain: "Storage", key: "snap-" },
  { type: "Lambda", domain: "Compute", key: "lambda" },
  { type: "Volume", domain: "Storage", key: "vol-" },
  { type: "Rds", domain: "Network", key: "rds-" },
  { type: "Cfn", domain: "Infra", key: "cloudformation-" },
  { type: "CloudWatchEventRule", domain: "Monitoring", key: "events-" },
  { type: "IAMRole", domain: "Security", key: "iam-" },
  { type: "S3", domain: "Compute", key: "S3-" },
  { type: "Subnet", domain: "Network", key: "Subnet-" },
  { type: "KeyPair", domain: "Network", key: "KeyPair-" },
  { type: "HostedZone", domain: "Compute", key: "hz-" },
  { type: "KMSKey", domain: "Network", key: "kms-" },
  { type: "Certificate", domain: "Security", key: "cert-" },
  { type: "Topic", domain: "Security", key: "t-" },
  { type: "IAMPolicy", domain: "Security", key: "ima-p-" },
  { type: "PeeringConnection", domain: "Network", key: "pc-" },
  { type: "FileSystem", domain: "Compute", key: "fs-" },
  { type: "ElasticIp", domain: "Network", key: "eip-" },
  { type: "Repository", domain: "Storage", key: "rp-" },
  { type: "VpcEndpoint", domain: "Network", key: "vpce-" },
  { type: "RouteTable", domain: "Storage", key: "rt-" },
  { type: "LoadBalancer", domain: "Compute", key: "lb-" },
  { type: "DynamoDbTable", domain: "Storage", key: "dynamo-" },
  { type: "AutoScalingGroup", domain: "Infra", key: "asg-" },
];

var nameType = ["FrontEnd", "Backend", "DB-Server", "DB-Staging"];

const addData = (data, depts) => {
  let selectedDept = faker.helpers.arrayElement(depts);
  let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
  let selectedDeptAcc = faker.helpers.arrayElement(selectedDept.deptAccounts);
  return {
    EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
    Domain: data.domain,
    ModifiedOn: faker.date.past(),
    AccountNumber: selectedDeptAcc.accountNumber,
    ResourceType: data.type,
    ResourceId: `${data.key}${faker.random.alphaNumeric(10)}`,
    Region: faker.helpers.arrayElement(regions).RegionCode,
    OrganizationId: uuidv4(),
    ModifiedBy: null,
    Departments: [selectedDept.deptId],
    CreatedBy: 2,
    Provider: "Aws",
    ResourceName:
      selectedDept.deptCode +
      "-" +
      faker.helpers.arrayElement(nameType) +
      "-" +
      selectedDeptApp.appEnv +
      "-" +
      data.key +
      faker.helpers.arrayElement([1, 2]),
    ApplicationId: selectedDeptApp && selectedDeptApp.appId,
    CreatedOn: faker.date.past(),
  };
};

export const getResources = async (deptId) => {
  let resources = [];
  const orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  resourcesTypes.forEach((resource) => {
    let res;
    for (let i = 0; i < 200; i++) {
      res = addData(resource, selectedOrg.depts);
      resources.push(res);
    }
  });
  return resources;
};
export const resourceSummary = {
  Subnet: 4,
  SecurityGroup: 1,
  S3: 2,
  Instance: 6,
  Volume: 8,
  IAMPolicy: 2,
  Lambda: 3,
};

export const ecsClusterResources = (
  departmentId = "98ea91b7-551f-4d35-a113-b37fcd840a71",
  accountNumber = "904433914959",
  regionCode,
  appId = "1",
  environmentId = "default"
) => {
  return [
    {
      ResourceName: "subnet-9567acpd",
      Provider: "Aws",
      ResourceId: "subnet-9567acpd",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:17:28",
      ResourceType: "Subnet",
      ResourceTags: [{ Key: "ApplicationId", Value: "001" }],
      Domain: "Infra",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:17:28",
      ModifiedBy: null,
      ARN: "arn:aws:subnet:us-east-1:904433914959:subnet:subnet-9567acpd",
    },
    {
      ResourceName: "subnet-8108eacd",
      Provider: "Aws",
      ResourceId: "subnet-8108eacd",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:17:28",
      ResourceType: "Subnet",
      ResourceTags: [{ Key: "ApplicationId", Value: "001" }],
      Domain: "Infra",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:17:28",
      ModifiedBy: null,
      ARN: "arn:aws:subnet:us-east-1:904433914959:subnet:subnet-8108eacd",
    },
    {
      ResourceName: "subnet-8125iead",
      Provider: "Aws",
      ResourceId: "subnet-8108iead",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:17:28",
      ResourceType: "Subnet",
      ResourceTags: [{ Key: "ApplicationId", Value: "001" }],
      Domain: "Infra",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:17:28",
      ModifiedBy: null,
      ARN: "arn:aws:subnet:us-east-1:904433914959:subnet:subnet-8108iead",
    },
    {
      ResourceName: "subnet-7342eacd",
      Provider: "Aws",
      ResourceId: "subnet-7342eacd",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:17:28",
      ResourceType: "Subnet",
      ResourceTags: [{ Key: "ApplicationId", Value: "001" }],
      Domain: "Infra",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:17:28",
      ModifiedBy: null,
      ARN: "arn:aws:subnet:us-east-1:904433914959:subnet:subnet-7342eacd",
    },
    {
      ResourceName: "launch-wizard-1",
      Provider: "Aws",
      ResourceId: "sg-08a0fe249e55xz1e7",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:17:28",
      ResourceType: "SecurityGroup",
      ResourceTags: [{ Key: "ApplicationId", Value: "001" }],
      Domain: "Infra",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:17:28",
      ModifiedBy: null,
      ARN: "arn:aws:sg:us-east-1:904433914959:group:sg-08a0fe249e55xz1e7",
    },
    {
      ResourceName:
        "setup-elastic-search-20-elsbackuprepositorybucke-2jegbj8sql60",
      Provider: "AWS",
      ResourceId:
        "arn:aws:s3:::setup-elastic-search-20-elsbackuprepositorybucke-2jegbj8sql60",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:16:51",
      ResourceType: "S3",
      ResourceTags: [
        {
          Key: "aws:cloudformation:stack-name",
          Value: "Setup-Elastic-Search--2019-10-03--14-46-31",
        },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search--2019-10-03--14-46-31/81831830-e5be-11e9-b45d-0a28f59d0ab4",
        },
        { Key: "Environment", Value: "Dev" },
        {
          Key: "aws:cloudformation:logical-id",
          Value: "ELSBackupRepositoryBucket",
        },
        { Key: "Vendor", Value: "MontyCloud" },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:16:51",
      ModifiedBy: null,
      ARN: "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search--2019-10-03--14-46-31/81831830-e5be-11e9-b45d-0a28f59d0ab4",
    },
    {
      ResourceName: "custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
      Provider: "AWS",
      ResourceId:
        "arn:aws:s3:::custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:16:51",
      ResourceType: "S3",
      ResourceTags: [
        {
          Key: "aws:cloudformation:stack-name",
          Value: "custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
        },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:16:51",
      ModifiedBy: null,
      ARN: "arn:aws:s3:::custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
    },
    {
      ResourceName: "elsmaster-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "i-04f07c78f13de298e",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:17",
      ResourceType: "Instance",
      ResourceTags: [
        {
          Key: "Name",
          Value: "elsmaster-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        { Key: "aws:cloudformation:logical-id", Value: "ELSMasterGroups" },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance1-XITPT45CAQDB/d84db8f0-e5be-11e9-8d87-0a4f04019892",
        },
        { Key: "Vendor", Value: "MontyCloud" },
        {
          Key: "es-cluster",
          Value: "elasticsearch-test-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        {
          Key: "aws:cloudformation:stack-name",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance1-XITPT45CAQDB",
        },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
        {
          Key: "MontyCloudTagId",
          Value: "57366fbc-189b-4eef-adb4-054b056af523",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "aws:autoscaling:groupName",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance1-XITPT45CAQDB-ELSMasterGroups-DZMQ47GESAEU",
        },
        {
          Key: "MontyCloudInventoryId",
          Value: "fddc300a-e182-46af-bfb2-49ea19b6ee0e",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:52",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance1-XITPT45CAQDB/d84db8f0-e5be-11e9-8d87-0a4f04019892",
    },
    {
      ResourceName: "elsdata-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "i-05f828d7a5b838841",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:11",
      ResourceType: "Instance",
      ResourceTags: [
        { Key: "aws:cloudformation:logical-id", Value: "ELSDataGroup" },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4/d8c077f0-e5be-11e9-9c3d-0e7f598ae3ee",
        },
        {
          Key: "MontyCloudTagId",
          Value: "57366fbc-189b-4eef-adb4-054b056af523",
        },
        {
          Key: "aws:cloudformation:stack-name",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4",
        },
        {
          Key: "aws:autoscaling:groupName",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4-ELSDataGroup-1B5MV6V6P2VTL",
        },
        { Key: "Vendor", Value: "MontyCloud" },
        {
          Key: "es-cluster",
          Value: "elasticsearch-test-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        {
          Key: "MontyCloudInventoryId",
          Value: "fddc300a-e182-46af-bfb2-49ea19b6ee0e",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        { Key: "Name", Value: "elsdata-80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:53",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/autoscaling-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4/d8c077f0-e5be-11e9-9c3d-0e7f598ae3ee",
    },
    {
      ResourceName: "",
      Provider: "AWS",
      ResourceId: "i-078c8ad2e59f52425",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:30:06",
      ResourceType: "Instance",
      ResourceTags: [
        { Key: "Vendor", Value: "MontyCloud" },
        {
          Key: "aws:cloudformation:stack-name",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z",
        },
        {
          Key: "aws:autoscaling:groupName",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z-ELSMasterGroup-6KRXVGE9IQF0",
        },
        { Key: "aws:cloudformation:logical-id", Value: "ELSMasterGroup" },
        { Key: "es-cluster", Value: "elasticsearch-test" },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z/d8b83a90-e5be-11e9-a5fe-0ec3f5318aae",
        },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
        {
          Key: "MontyCloudInventoryId",
          Value: "fddc300a-e182-46af-bfb2-49ea19b6ee0e",
        },
        {
          Key: "MontyCloudTagId",
          Value: "57366fbc-189b-4eef-adb4-054b056af523",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:30:05",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-Instance2-1P6UO3831QL9Z/d8b83a90-e5be-11e9-a5fe-0ec3f5318aae",
    },
    {
      ResourceName: "elsmaster-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "i-0a81d1ddaec473db6",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:24",
      ResourceType: "Instance",
      ResourceTags: [
        {
          Key: "MontyCloudTagId",
          Value: "57366fbc-189b-4eef-adb4-054b056af523",
        },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
        {
          Key: "aws:cloudformation:stack-name",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z",
        },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z/d8b83a90-e5be-11e9-a5fe-0ec3f5318aae",
        },
        {
          Key: "Name",
          Value: "elsmaster-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        {
          Key: "MontyCloudInventoryId",
          Value: "fddc300a-e182-46af-bfb2-49ea19b6ee0e",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "aws:autoscaling:groupName",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance2-1P6UO3831QL9Z-ELSMasterGroup-6KRXVGE9IQF0",
        },
        { Key: "aws:cloudformation:logical-id", Value: "ELSMasterGroup" },
        { Key: "Vendor", Value: "MontyCloud" },
        {
          Key: "es-cluster",
          Value: "elasticsearch-test-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:53",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-10-03-14-46-31-MasterNodeInstance5-1P6UO3831AS09/d8b83a90-e5be-11e9-a5fe-0ec3f5318aae",
    },
    {
      ResourceName: "elsdata-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "i-0cd436fc681f9d81c",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:22",
      ResourceType: "Instance",
      ResourceTags: [
        {
          Key: "MontyCloudTagId",
          Value: "57366fbc-189b-4eef-adb4-054b056af523",
        },
        { Key: "Vendor", Value: "MontyCloud" },
        {
          Key: "aws:cloudformation:stack-name",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4",
        },
        {
          Key: "es-cluster",
          Value: "elasticsearch-test-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        {
          Key: "aws:cloudformation:stack-id",
          Value:
            "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4/d8c077f0-e5be-11e9-9c3d-0e7f598ae3ee",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "MontyCloudInventoryId",
          Value: "fddc300a-e182-46af-bfb2-49ea19b6ee0e",
        },
        { Key: "Application", Value: "ECS-Cluster-Dev" },
        { Key: "Name", Value: "elsdata-80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "aws:autoscaling:groupName",
          Value:
            "Setup-Elastic-Search-2019-10-03-14-46-31-DataNodeInstance1-QQCND5NQW1L4-ELSDataGroup-1B5MV6V6P2VTL",
        },
        { Key: "aws:cloudformation:logical-id", Value: "ELSDataGroup" },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:54",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-12-25-14-46-31-NodeInstance3-QQCND5CAB1L4/d8c077f0-e5be-11e9-9c3d-0e7g45th98e",
    },
    {
      ResourceName: "i-79e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "i-0cd79efc681f9d81c",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:22",
      ResourceType: "Instance",
      ResourceTags: [
        {
          Key: "MontyCloudTagId",
          Value: "i-79e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:54",
      ModifiedBy: null,
      ARN: "arn:aws:instance:us-east-1:904433914959:stack/Setup-Elastic-Search-2019-12-25-14-46-31-NodeInstance3-QQCND5CAB1L4/d8c077f0-e5be-11e9-9c3d-0e7g45th98e",
    },
    {
      ResourceName: "elsdata-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-00af97e6fd925e9e0",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:20",
      ResourceType: "Volume",
      ResourceTags: [
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "Name",
          Value: "elsdata-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:20:00",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-00af97e6fd925e9e0",
    },
    {
      ResourceName: "elsmaster-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-00e293226b4b22957",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:16",
      ResourceType: "Volume",
      ResourceTags: [
        {
          Key: "Name",
          Value: "elsmaster-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:56",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-00e293226b4b22957",
    },
    {
      ResourceName: "elsdata-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-0449949adb3825c32",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:06",
      ResourceType: "Volume",
      ResourceTags: [
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "Name",
          Value: "elsdata-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:58",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-0449949adb3825c32",
    },
    {
      ResourceName: "elsdata-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-06c81b36b312fcd2c",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:17",
      ResourceType: "Volume",
      ResourceTags: [
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "Name",
          Value: "elsdata-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:20:00",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-06c81b36b312fcd2c",
    },
    {
      ResourceName: "elsmaster-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-06e751d1f4bff6311",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:23",
      ResourceType: "Volume",
      ResourceTags: [
        {
          Key: "Name",
          Value: "elsmaster-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:58",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-06e751d1f4bff6311",
    },
    {
      ResourceName: "elsdata-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-0a2b69f9be0f9d866",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:08",
      ResourceType: "Volume",
      ResourceTags: [
        {
          Key: "Name",
          Value: "elsdata-ExtdVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-0a2b69f9be0f9d866",
    },
    {
      ResourceName: "elsmaster-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-0c0e7d84aea639f2d",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:21",
      ResourceType: "Volume",
      ResourceTags: [
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
        {
          Key: "Name",
          Value: "elsmaster-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:59",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-0c0e7d84aea639f2d",
    },
    {
      ResourceName: "elsmaster-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
      Provider: "AWS",
      ResourceId: "vol-0eb3edfb1eda97098",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Volume",
      ResourceTags: [
        {
          Key: "Name",
          Value: "elsmaster-RootVol-80e75ebb-077a-436e-af0a-0cd88390d658",
        },
        { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      ],
      Domain: "Storage",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:volume:us-east-1:904433914959:volume:vol-0eb3edfb1eda97098",
    },
    {
      ResourceName: "LSQClearDynamoDBLogs-Policy-v3",
      Provider: "AWS",
      ResourceId: "ANPA6A6SS452A2ISZRTX5",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "IAMPolicy",
      ResourceTags: [
        {
          Key: "Name",
          Value: "LSQClearDynamoDBLogs-Policy-v3",
        },
      ],
      Domain: "Security",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:iam:us-east-1:904433914959:policy:LSQClearDynamoDBLogs-Policy-v3",
    },
    {
      ResourceName: "DynamoDBLogs-Policy-v3",
      Provider: "AWS",
      ResourceId: "ARPA6A66T452Y2ISZRTX5",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "IAMPolicy",
      ResourceTags: [
        {
          Key: "Name",
          Value: "DynamoDBLogs-Policy-v3",
        },
      ],
      Domain: "Security",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:iam:us-east-1:904433914959:policy:DynamoDBLogs-Policy-v3",
    },
    {
      ResourceName: "UpdateEC2AccessPolicy",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:UpdateEC2AccessPolicy",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "UpdateEC2AccessPolicy",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:UpdateEC2AccessPolicy",
    },
    {
      ResourceName: "Create-Snapshot-List",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:Create-Snapshot-List",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "Create-Snapshot-List",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:Create-Snapshot-List",
    },
    {
      ResourceName: "Verify-Snapshots",
      Provider: "AWS",
      ResourceId:
        "arn:aws:lambda:us-east-1:904433914959:function:Verify-Snapshots",
      Region: regionCode ? regionCode : "us-east-1",
      Departments: [departmentId],
      EnvironmentId: environmentId,
      CreatedBy: null,
      ModifiedOn: "2019-10-03 09:22:14",
      ResourceType: "Lambda",
      ResourceTags: [
        {
          Key: "Name",
          Value: "Verify-Snapshots",
        },
      ],
      Domain: "Compute",
      AccountNumber: accountNumber,
      OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
      ApplicationId: appId,
      CreatedOn: "2019-10-03 09:19:57",
      ModifiedBy: null,
      ARN: "arn:aws:lambda:us-east-1:904433914959:function:Verify-Snapshots",
    },
  ];
};
